import PropTypes from 'prop-types';

import DrawerHeaderStyled from './DrawerHeaderStyled';
import Logo from 'components/logo';

// ==============================|| DRAWER HEADER ||============================== //

export default function DrawerHeader({ open }) {
  return (
    <DrawerHeaderStyled
      open={open}
      sx={{
        height: 64,
        minHeight: '64px !important',
        width: 'initial',
        py: 0,
        px: open ? 2 : 0,
        borderBottom: '1px solid',
        borderColor: 'divider'
      }}
    >
      <Logo isIcon={!open} sx={{ height: 56, display: 'flex', alignItems: 'center' }} />
    </DrawerHeaderStyled>
  );
}

DrawerHeader.propTypes = { open: PropTypes.bool };
